import { render } from "./RetailTerms.vue?vue&type=template&id=1491e136&scoped=true"
import script from "./RetailTerms.vue?vue&type=script&lang=js"
export * from "./RetailTerms.vue?vue&type=script&lang=js"

import "./RetailTerms.vue?vue&type=style&index=0&id=1491e136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1491e136"]])

export default __exports__